/* eslint-disable no-unused-vars */
/* eslint-disable no-console */

import Vue from "vue";
import Apps from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import moment from "moment";
import axios from "axios";

Vue.config.productionTip = false;
Vue.filter("myDate", function(created) {
  return moment(created).format("MMMM Do YYYY");
});
Vue.use(router);
document.cookie = "cross-site-cookie=image; SameSite=None; Secure";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.headers.post["Credentials"] = true;
new Vue({
  vuetify,
  store,
  router,

  render: (h) => h(Apps),
}).$mount("#app");
